import type { Schema, SchemaField } from '@cli-types/core-engine/schema.js'
import { flattenFields } from '@core-engine/schema/field-helpers/flattening/flatten-fields.js'
import { isLayoutField } from '@core-engine/schema/field-type-guards/is-layout-field.js'
import { createAuthorshipFields } from '@next-adapter/generators/actions/action-helpers/create-authorship-fields.js'
export function getSingleAllDbFields(schema: Schema): SchemaField[] {
  const dbFields = flattenFields(schema.fields).filter(
    (field) =>
      !(field.type === 'relationship' && field.multiple === true) && !isLayoutField(field.type)
  )
  const allDbFields = [...dbFields]

  if (!allDbFields.some((field) => field.name === 'createdAt')) {
    allDbFields.push({ name: 'createdAt', type: 'timestamp' as const, required: true })
  }
  if (!allDbFields.some((field) => field.name === 'updatedAt')) {
    allDbFields.push({ name: 'updatedAt', type: 'timestamp' as const, required: true })
  }
  for (const field of createAuthorshipFields()) {
    if (!allDbFields.some((dbField) => dbField.name === field.name)) {
      allDbFields.push(field)
    }
  }

  return allDbFields
}
